import { Injectable } from '@angular/core';
import { OclLinkedItemsStoreManager } from '../../../ocl/store/linked-items/ocl-linked-items-store-manager.service';
import { RequestService } from '../../../common/services/request.service';
import { OclLinksService } from 'src/app/ocl/services/ocl-links-service/ocl-links.service';
import { GocModuleConfigService } from '../goc-module-config/goc-module-config.service';

@Injectable({
  providedIn: 'root',
})
export class GocLinksService extends OclLinksService {
  // tslint:disable:variable-name
  protected ParseOclLogBook = Parse.Object.extend('GOCLogBook');
  protected ParseOclEvents = Parse.Object.extend('GOCEvents');
  protected ParseOclDecisions = Parse.Object.extend('GOCDecisions');
  protected ParseOclLinkLogBookDecision = Parse.Object.extend('GOCLinkLogBookDecision');
  protected ParseOclLinkDecisionEvent = Parse.Object.extend('GOCLinkDecisionEvent');
  protected ParseOclLinkLogBookEvent = Parse.Object.extend('GOCLinkLogBookEvent');
  // tslint:enabled
  public constructor(
    protected requestService: RequestService,
    protected linkedItemsStoreManager: OclLinkedItemsStoreManager,
    public moduleConfig: GocModuleConfigService
  ) {
    super(requestService, linkedItemsStoreManager, moduleConfig);
  }
}
